import React from 'react';
import * as Ons from 'react-onsenui';
import packageJson from '../../../../package.json';
import { reload } from '../../util';
import { getContexts } from '../../util/context';
import { translate as _, getLanguages } from '../../util/i18n';
import { getErrorMessage } from '../../util/error';
import { showAlert } from '../../util/ui';
import logo from '../../../img/logos/dp-logo.png';
import { RESETTING_PASSWORD_SUCCEEDED, SENDING_PASSWORD_RECOVERY_SUCCEEDED } from '../../store/constants/actionTypes';

class Login extends React.Component {

    #contexts;
    #languages;

    constructor( props ) {

        super( props );

        // console.log( 'components.pages.Login.constructor()', props );

        this.state = {
            username:                 '',
            password:                 '',
            context:                  props.context,
            newPassword:              '',
            newPasswordRepeat:        '',
            passwordRecovery:         false,
            passwordRecoveryUsername: ''
        };

        this.handleContextChange             = this.handleContextChange.bind( this );
        this.handleErrorDismiss              = this.handleErrorDismiss.bind( this );
        this.handleForgotPasswordClick       = this.handleForgotPasswordClick.bind( this );
        this.handleInputChange               = this.handleInputChange.bind( this );
        this.handleLanguageSelection         = this.handleLanguageSelection.bind( this );
        this.handleLogin                     = this.handleLogin.bind( this );
        this.handleResetPasswordClick        = this.handleResetPasswordClick.bind( this );
        this.handleSendPasswordRecoveryClick = this.handleSendPasswordRecoveryClick.bind( this );
        this.handleToLoginClick              = this.handleToLoginClick.bind( this );

        this.#contexts  = getContexts();
        this.#languages = getLanguages();

    }

    handleInputChange( e ) {

        this.setState( { [ e.target.name ]: e.target.value } );

    }

    handleContextChange( e ) {

        // e.index is always -1 on Android! Onsen bug?
        // const index = e.target.value;
        const index   = Number( e.target.querySelector( 'input:checked' ).value );
        const context = this.#contexts[ index ].key;

        this.setState( { context }, () => this.props.onSetContext( context ) );

    }

    handleForgotPasswordClick( e ) {

        e.preventDefault();

        this.setState( { passwordRecovery: true } );

        setTimeout( () => document.querySelector( '#passwordRecoveryUsername input' ).focus(), 200 );

    }

    handleLanguageSelection( e ) {

        this.props.onSelectLanguage( e );

        reload();

    }

    handleLogin( e ) {

        e.preventDefault();

        if ( ! this.state.username ) {

            return document.querySelector( '#username input' ).focus();

        }

        if ( ! this.state.password ) {

            return document.querySelector( '#password input' ).focus();

        }

        this.props.onLogin( this.state.context, this.state.username, this.state.password );

    }

    handleErrorDismiss() {

        this.props.onDismissError();

    }

    handleResetPasswordClick( e ) {

        e.preventDefault();

        if ( ! this.state.newPassword ) {

            return document.querySelector( '#newPassword input' ).focus();

        }

        if ( ! this.state.newPasswordRepeat ) {

            return document.querySelector( '#newPasswordRepeat input' ).focus();

        }

        if ( this.state.newPassword !== this.state.newPasswordRepeat ) {

            return showAlert( {

                buttonLabels: [ _( 'Schließen' ) ],
                cancelable:   true,
                message:      _( 'Die eingegeben Passwörter stimmen nicht überein.' ),
                title:        ''

            } );

        }

        this.props.onResetPassword( this.state.context, this.props.resetPasswordToken, this.state.newPasswordRepeat );

    }

    handleSendPasswordRecoveryClick( e ) {

        e.preventDefault();

        if ( ! this.state.passwordRecoveryUsername ) {

            return document.querySelector( '#passwordRecoveryUsername input' ).focus();

        }

        this.props.onSendPasswordRecovery( this.state.context, this.state.passwordRecoveryUsername );

    }

    handleToLoginClick() {

        if ( this.props.resetPasswordToken ) {

            window.location.search = '';

        } else {

            this.setState( { passwordRecovery: false, passwordRecoveryUsername: '' } );

            this.props.loadingSucceeded && this.props.onDismissLoadingSucceeded();

        }

    }

    renderContextFormControl() {

        return (

            <div className="form-control">

                <Ons.Segment index={this.#contexts.findIndex( context => this.state.context === context.key )} onPostChange={this.handleContextChange}>

                    {this.#contexts.map( context => <Ons.Button key={context.key}>{_( context.label )}</Ons.Button> )}

                </Ons.Segment>

            </div>

        );

    }

    render() {

        return (

            <Ons.Page className="login-page">

                <Ons.AlertDialog isOpen={!! this.props.error} onCancel={this.handleErrorDismiss} cancelable>
                    <div className="alert-dialog-title">{_( 'Fehler!' )}</div>
                    <div className="alert-dialog-content">{this.props.error && getErrorMessage( this.props.error.code )}</div>
                    <div className="alert-dialog-footer">
                        <Ons.AlertDialogButton onClick={this.handleErrorDismiss}>{_( 'OK' )}</Ons.AlertDialogButton>
                    </div>
                </Ons.AlertDialog>

                <div className="wrapper">

                    <form autoComplete="off" onSubmit={this.handleLogin} className="form">

                        <div className="logo"><img src={logo} alt="Logo" /></div>

                        <Ons.Card>

                            <fieldset disabled={this.props.loading}>

                                {this.props.resetPasswordToken ?

                                    ( this.props.loadingSucceeded === RESETTING_PASSWORD_SUCCEEDED ?

                                        <>

                                            <h2>{_( 'Passwort zurückgesetzt!' )}</h2>

                                            <p>{_( 'Du kannst dich nun mit deinem Benutzernamen und deinem neuen Passwort einloggen.' )}</p>

                                            <div className="form-control">

                                                <Ons.Button modifier="large quiet" onClick={this.handleToLoginClick}>{_( 'Weiter zum Login' )} <Ons.Icon icon="angle-double-right" /></Ons.Button>

                                            </div>

                                        </>

                                    :

                                        <>

                                            <h2>{_( 'Passwort zurücksetzen' )}</h2>

                                            <div className="alert alert-info">{_( 'Bitte wähle ein neues Passwort.' ) + ' ' + _( 'Wir empfehlen eine Mischung aus Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen sowie mindestens 8 Zeichen.' )}</div>

                                            <div className="form-control">

                                                <label htmlFor="newPassword">{_( 'Neues Passwort' )}</label>
                                                <Ons.Input type="password" modifier="underbar" value={this.state.newPassword} onChange={this.handleInputChange} id="newPassword" name="newPassword" />

                                            </div>

                                            <div className="form-control">

                                                <label htmlFor="newPasswordRepeat">{_( 'Neues Passwort wiederholen' )}</label>
                                                <Ons.Input type="password" modifier="underbar" value={this.state.newPasswordRepeat} onChange={this.handleInputChange} id="newPasswordRepeat" name="newPasswordRepeat" />

                                            </div>

                                            <div className="form-control">

                                                <Ons.Button modifier="quiet" onClick={this.handleToLoginClick} disabled={this.props.loading}><Ons.Icon icon="angle-double-left" /> {_( 'Zum Login' )}</Ons.Button>

                                                <Ons.Button onClick={this.handleResetPasswordClick} disabled={this.props.loading} className="pull-right">{_( 'Zurücksetzen' )}</Ons.Button>

                                            </div>

                                        </>

                                    )

                                : this.props.loadingSucceeded === SENDING_PASSWORD_RECOVERY_SUCCEEDED ?

                                    <>

                                        <h2>{_( 'Du hast eine Nachricht!' )}</h2>

                                        <p>{_( 'Ein E-Mail zum Zurücksetzen deines Passworts wurde an deine E-Mail-Adresse gesendet.' )}</p>

                                        <p>{_( 'Solltest du kein E-Mail bekommen, überprüfe bitte den Spam-Ordner.' )}</p>

                                        <div className="form-control">

                                            <Ons.Button modifier="large quiet" onClick={this.handleToLoginClick}>{_( 'Weiter zum Login' )} <Ons.Icon icon="angle-double-right" /></Ons.Button>

                                        </div>

                                    </>

                                : this.state.passwordRecovery ?

                                    <>

                                        <h2>{_( 'Passworthilfe' )}</h2>

                                        <div className="alert alert-info">{_( 'Gib deinen Benutzernamen ein.' ) + ' ' + _( 'Nach dem Absenden erhältst du ein E-Mail zum Zurücksetzen deines Passworts.' ) + ' ' + _( 'Solltest du kein E-Mail bekommen, überprüfe bitte den Spam-Ordner.' )}</div>

                                        <div className="form-control">

                                            <label htmlFor="passwordRecoveryUsername">{_( 'Benutzername' )}</label>
                                            <Ons.Input type="text" modifier="underbar" value={this.state.passwordRecoveryUsername} onChange={this.handleInputChange} id="passwordRecoveryUsername" name="passwordRecoveryUsername" />

                                        </div>

                                        {this.renderContextFormControl()}

                                        <div className="form-control">

                                            <Ons.Button modifier="quiet" onClick={this.handleToLoginClick} disabled={this.props.loading}><Ons.Icon icon="angle-double-left" /> {_( 'Zurück' )}</Ons.Button>

                                            <Ons.Button onClick={this.handleSendPasswordRecoveryClick} disabled={this.props.loading} className="pull-right">{_( 'Senden' )}</Ons.Button>

                                        </div>

                                    </>

                                :

                                    <>

                                        <div className="form-control">

                                            <label htmlFor="username">{_( 'Benutzername' )}</label>
                                            <Ons.Input type="text" modifier="underbar" value={this.state.username} onChange={this.handleInputChange} id="username" name="username" autofocus />

                                        </div>

                                        <div className="form-control">

                                            <label htmlFor="password">{_( 'Passwort' )}</label>
                                            <Ons.Input type="password" modifier="underbar" value={this.state.password} onChange={this.handleInputChange} id="password" name="password" />

                                        </div>

                                        {this.renderContextFormControl()}

                                        <div className="form-control">

                                            <Ons.Button modifier="large" onClick={this.handleLogin} disabled={this.props.loading}>{_( 'Login' )}</Ons.Button>

                                        </div>

                                        <a href="#password-recovery" onClick={this.handleForgotPasswordClick}>{_( 'Passwort vergessen?' )}</a>

                                        {this.props.loading && <div className="loading"><Ons.ProgressCircular indeterminate /></div>}

                                    </>

                                }

                            </fieldset>

                        </Ons.Card>

                    </form>

                    <div className="languages">

                        {this.#languages.map( ( e, i ) => <span key={i} onClick={() => this.handleLanguageSelection( i )} className={this.props.language === i ? 'active' : ''}>{e.label}</span> )}

                    </div>

                    <div className="version">{_( 'Digitaler Spielerpass' )} v{packageJson.version}</div>

                </div>

            </Ons.Page>

        );

    }

}

export default Login;